import { useZervantSubscriptionDetails } from '@features/zervant-subscription/hooks/useZervantSubscriptionDetails'

import { useOrganizationSubscription } from '../../../../../hooks'
import { useOrganizationUiSetup } from '../../../../../hooks/useOrganizationUiSetup'

export const useShowStripePortalSubscription = () => {
  const { isUiSetupShineInvoicingAccounting } = useOrganizationUiSetup()
  const { isLoading: isLoadingSubscription, hasAccountingSubscription } = useOrganizationSubscription()
  const { isInZervantNoPlan, isLoading: isLoadingZervantSubscription } = useZervantSubscriptionDetails()

  const isLoading = isLoadingSubscription || isLoadingZervantSubscription

  if (isUiSetupShineInvoicingAccounting) {
    const hasZervantSubscription = !isInZervantNoPlan
    const isPortalLoading = hasZervantSubscription && isLoading
    return {
      isLoading: isPortalLoading,
      showStripePortal: !isLoading && hasZervantSubscription && !hasAccountingSubscription,
    }
  }

  return { isLoading, showStripePortal: false }
}
